import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, forkJoin, of } from 'rxjs';
import { FhirFacadeService } from '@app/shared/services/fhir-facade';
import { SessionStorageService } from '@app/core/auth/session-storage';
import { catchError, map } from 'rxjs';
import { PractitionerResource } from '@app/shared/models/facade-response.model';

export type FacadeResolveResult =
  | {
      status: 'success';
      practitioner: PractitionerResource;
    }
  | {
      status: 'error';
      error?: unknown;
    };

@Injectable({ providedIn: 'root' })
export class FacadeResolver implements Resolve<FacadeResolveResult> {
  constructor(
    private facadeService: FhirFacadeService,
    private sessionService: SessionStorageService,
  ) {}

  resolve(): Observable<FacadeResolveResult> {
    const userName = this.sessionService.getUserName();
    if (userName) {
      const practitioner: PractitionerResource = {
        resourceType: 'Practitioner',
        name: [
          {
            extension: [
              {
                url: 'http://hl7.org/fhir/StructureDefinition/iso21090-EN-representation',
                valueCode: 'IDE',
              },
            ],
            text: userName,
          },
        ],
      };
      return of({ status: 'success', practitioner });
    }

    return forkJoin({
      practitioner: this.facadeService.fetchFacadePractitioner(
        this.sessionService.getHospitalCode(),
        this.sessionService.getUserId(),
      ),
    }).pipe(
      map(({ practitioner }) => ({
        status: 'success' as const,
        practitioner,
      })),
      catchError((err: unknown) => {
        return of<FacadeResolveResult>({
          status: 'error',
          error: err,
        });
      }),
    );
  }
}
